import { Box, Heading, Icon, Image, List, Paragraph } from '@zillow/constellation-10';
import { IconEditOutline, IconLightBulbOutline, IconSendOutline } from '@zillow/constellation-icons';
import ContractFinanceLight from '../../../../../images/contractFinanceLight.svg';

export function Landing() {
  return (
    <>
      <Image src={ContractFinanceLight} alt="pen signing a piece of paper with a dollar sign" />
      <Heading level={2} css={{ textStyle: 'responsive.heading-md', marginTop: 'looser', marginBottom: 'looser' }}>
        How to ask for a renewal
      </Heading>
      <List.Root appearance="none">
        <List.Item>
          <Box css={{ display: 'flex', gap: 'tight', marginBottom: 'looser' }}>
            <Icon css={{ flexShrink: 0 }}>
              <IconLightBulbOutline />
            </Icon>
            <Paragraph>Decide what to propose adding to your lease renewal (we’ll help)</Paragraph>
          </Box>
        </List.Item>
        <List.Item>
          <Box css={{ display: 'flex', gap: 'tight', marginBottom: 'looser' }}>
            <Icon css={{ flexShrink: 0 }}>
              <IconEditOutline />
            </Icon>
            <Paragraph>Highlight how you’re a great tenant — we’ll use that info to draft a message for you</Paragraph>
          </Box>
        </List.Item>
        <List.Item>
          <Box css={{ display: 'flex', gap: 'tight' }}>
            <Icon css={{ flexShrink: 0 }}>
              <IconSendOutline />
            </Icon>
            <Paragraph>Review, edit, and send it to your landlord</Paragraph>
          </Box>
        </List.Item>
      </List.Root>
    </>
  );
}
